import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormRendererComponent, FormatSpacePipe } from '@alfresco/adf-core';

import { WkFormsComponent } from './wk-forms.component';

@NgModule({
  declarations: [WkFormsComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule,
    FormRendererComponent,
    FormatSpacePipe,
  ],
  exports: [WkFormsComponent],
})
export class WkFormsModule {}
